const TmpPE025 = (page) => {
  const modifiedPage = {
    ...page
  };
  const media = [];
  let transcript = '';

  // Inject page.id into each focus point if present
  if (Array.isArray(page.focusPointsData)) {
    page.focusPointsData.forEach((fp) => {
      fp.page = page.id;
    });
  }

  page.content.core.forEach((segment, sIndex) => {
    if (sIndex === 0) {
      transcript += segment.text_tl;
    } else {
      transcript += ' ' + segment.text_tl;
    }
  });

  const npcVideo = {
    id: page.id,
    page: page.id,
    author: 'Team ACV/AAC',
    author_desc_en: 'Team ACV/AAC',
    author_desc_tl: 'N/A',
    cc_license: 'N/A',
    description: 'NPC Video',
    downloaded_date: new Date().toISOString(),
    published_date: new Date().toISOString(),
    media_url: 'https://base-media-repo.web.app/' + page.label.slice(0, 2).toUpperCase() + '/video/' + page.label.toLowerCase().replaceAll('-', '_') + '.mp4',
    source_url: 'Team ACV/AAC',
    src: page.label.toLowerCase().replaceAll('-', '_') + '.mp4',
    title_en: 'N/A',
    title_tl: 'N/A',
    transcript: transcript,
    type: 'video'
  };

  modifiedPage.title = "Argument/Counter Argument";

  modifiedPage.content.media = npcVideo;

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE025;
